export default __webpack_public_path__ + "static/media/_DUA5003.38f44ee6.jpeg";